// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LS5ga{margin-top:16px;margin-top:1rem;padding-top:16px;padding-top:1rem;padding-bottom:16px;padding-bottom:1rem}
.LS5ga .border-secondary{border-color:#cbd5e1 !important;margin-bottom:0}
.LS5ga .ms-3{margin-left:16px !important;margin-left:1rem !important}
.LS5ga .me-3{margin-right:16px !important;margin-right:1rem !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepFooterContainer": `LS5ga`
};
module.exports = ___CSS_LOADER_EXPORT___;
